import {
    crossPromoVkMusicFakedoor,
    crossPromoVkMusicFakedoorTariff,
} from 'reactApp/appHelpers/featuresHelpers/features/crossPromoVkMusicFakedoor';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { billingDataFailure, getBillingDataRequest, getBillingDataSuccess } from 'reactApp/modules/billingData/billingData.module';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { type RootState, store as reduxStore } from 'reactApp/store';
import { crossPromoVkMusicFakedoorModalAnalyticsMap } from 'reactApp/ui/CrossPromoVkMusicFakedoorModal/CrossPromoVkMusicFakedoorModal.analytics';
import { renderCrossPromoVkMusicFakedoorModal } from 'reactApp/ui/CrossPromoVkMusicFakedoorModal/CrossPromoVkMusicFakedoorModal.helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { call, put, select, take } from 'typed-redux-saga';

const CROSS_PROMO_VK_MUSIC_FAKEDOOR_ID = 'cross-promo-vk-music-fakedoor';

export function* initCrossPromoVkMusicModal() {
    const storage = yield* select(getCurrentStorage);
    const isCorrectUrl = storage === EStorageType.home;

    if (
        storeHelper.getValue(CROSS_PROMO_VK_MUSIC_FAKEDOOR_ID) ||
        !isCorrectUrl ||
        !crossPromoVkMusicFakedoor ||
        !crossPromoVkMusicFakedoorTariff
    ) {
        return;
    }

    yield put(getBillingDataRequest({ radar: 'subs' }));
    yield take([getBillingDataSuccess, billingDataFailure]);
    const list = yield select((state: RootState) =>
        BillingDataSelectors.getSortedMonthSubscriptionsBySpaces(state, [SPACE_LIST.gb_64, SPACE_LIST.gb_128, SPACE_LIST.gb_256])
    );
    if (!list.length) {
        return;
    }

    const price = list[0].renewalCost || list[0].purchaseCost;
    if (!price) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.crossPromoVkMusicFakedoor,
            promoId: CROSS_PROMO_VK_MUSIC_FAKEDOOR_ID,
            onClick() {
                sendPaymentGa({
                    action: 'click',
                    eventCategory: ECategoryGa.modal,
                    name: crossPromoVkMusicFakedoorModalAnalyticsMap[crossPromoVkMusicFakedoor],
                });
                reduxStore.dispatch(removePromo(EPromoType.crossPromoVkMusicFakedoor));
            },
            onShow: () => {
                storeHelper.markAsShown(CROSS_PROMO_VK_MUSIC_FAKEDOOR_ID);
                sendPaymentGa({
                    action: 'show',
                    eventCategory: ECategoryGa.modal,
                    name: crossPromoVkMusicFakedoorModalAnalyticsMap[crossPromoVkMusicFakedoor],
                });
                reduxStore.dispatch(promoShown(EPromoType.crossPromoVkMusicFakedoor));
            },
            onClose: () => {
                sendPaymentGa({
                    action: 'close',
                    eventCategory: ECategoryGa.modal,
                    name: crossPromoVkMusicFakedoorModalAnalyticsMap[crossPromoVkMusicFakedoor],
                });
                reduxStore.dispatch(removePromo(EPromoType.crossPromoVkMusicFakedoor));
            },
            onSecondary: () => {
                sendPaymentGa({
                    action: 'click-reject',
                    eventCategory: ECategoryGa.modal,
                    name: crossPromoVkMusicFakedoorModalAnalyticsMap[crossPromoVkMusicFakedoor],
                });
                reduxStore.dispatch(removePromo(EPromoType.crossPromoVkMusicFakedoor));
            },
            price,
        })
    );
}

export function* showCrossPromoVkMusicModal() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.crossPromoVkMusicFakedoor));

    if (promo) {
        const { onShow, onClick, onClose, onSecondary, price } = promo;
        yield call(renderCrossPromoVkMusicFakedoorModal, { onShow, onClick, onClose, onSecondary, price });
    }
}
